import { createApp } from 'vue'
import { createPinia } from 'pinia'
import naive from 'naive-ui'
import { installNaiveA11y } from '@architeia/naive-a11y'
import App from './App.vue'
import router from './router'
import { i18n } from './i18n'
import '@fontsource-variable/source-serif-4/wght.css'
import '@fontsource-variable/source-serif-4/wght-italic.css'
import '../../../libs/design-tokens/garden.css'
import './style.css'
import { getRuntimeConfig } from '@architeia/config'

// AINFRA-171: stop here, with a visible error, when /config.js is missing or invalid.
getRuntimeConfig()

const app = createApp(App)
app.use(createPinia())
app.use(i18n)
app.use(naive)
app.use(router)
app.mount('#app')

// KORA-156: fill Naive UI's accessibility gaps (form labels, select roles, keyboard access to the
// menu, pagination and checkable tags, card heading levels, announced toasts).
installNaiveA11y()
